<template>
  <section id="login" class="fill-height">
    <v-container style="height: inehit" class="fill-height px-7 px-md-5 justify-center">
      <v-row justify="space-around" align="center">
        <v-col cols="12" sm="10" md="6" xl="4" class="text-center">
          <v-img
            :src="require('../../assets/brand/logo1.png')"
            alt="PBXBerry brand"
            width="45vh"
            class="mx-auto"
            contain
          ></v-img>
          <!-- <h1 class="mt-7 mt-md-12 headline">Bienvenido</h1> -->
          <p class="mt-8 mb-6">
            ¡Bienvenido! Introduzca sus credenciales para acceder.
          </p>
          <ValidationObserver ref="obs" v-slot="{ passes }">
            <v-form @submit.prevent="passes(login)">
              <ValidationProvider name="correo electrónico" rules="email|required" v-slot="{ errors }">
                <v-text-field
                  required
                  filled
                  rounded
                  label="Correo electrónico"
                  name="email"
                  prepend-inner-icon="mdi-email"
                  type="text"
                  color="secondary"
                  v-model="email"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>

              <ValidationProvider name="contraseña" rules="required" v-slot="{ errors }">
                <v-text-field
                  required
                  filled
                  rounded
                  label="Contraseña"
                  name="password"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  :type="showPassword ? 'text' : 'password'"
                  color="secondary"
                  v-model="password"
                  :error-messages="errors"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </ValidationProvider>

              <!-- <v-row no-gutters class="mx-1" justify="space-between">
                <v-col cols="12" md="auto">
                  <v-checkbox
                    class="mt-0"
                    label="Recuérdame"
                    color="secondary"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="auto" class="d-none d-md-block mt-1">
                  <a href>Olvidé mi contraseña</a>
                </v-col>
              </v-row> -->

              <v-btn
                rounded
                dark
                block
                x-large
                type="submit"
                class="btn-primary-shadow"
                color="primary"
                :loading="loading"
                >Entrar</v-btn
              >

              <v-col cols="12" md="auto" class="d-block d-md-none mt-6">
                <a href>Olvidé mi contraseña</a>
              </v-col>
            </v-form>

            <v-dialog v-model="sessionDialog" max-width="420">
              <v-card>
                <v-card-title class="text-h6">
                  Sesión activa detectada
                </v-card-title>

                <v-card-text>
                  El usuario ya posee una sesión activa.<br />
                  ¿Desea finalizar la sesión activa y continuar acá?
                </v-card-text>

                <v-card-actions class="justify-end">
                  <v-btn text @click="sessionDialog = false">
                    No
                  </v-btn>

                  <v-btn rounded color="success" class="px-8" @click="handleRenewSession" :loading="loading">
                    Sí, continuar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { load } from "recaptcha-v3";
import { checkNotificationPermission } from "@/components/Utils/SIPHelpers";
import { getFirebaseToken } from "@/components/Utils/getFirebaseToken";
import { PbxPublicHttpClient } from "@/services/httpclient";

export default {
  data: () => ({
    email: "",
    password: "",
    remember: false,
    showPassword: false,
    loading: false,
    sessionDialog: false,
    sessionData: null,
  }),

  created() {
    let theme = localStorage.getItem("theme");
    let isTrueSet = theme == "true";
    this.$vuetify.theme.dark = isTrueSet;
    checkNotificationPermission();
  },

  methods: {
    // FUNCION CORRECTA (VERIFICACION DE DATOS)
    async login() {
      try {
        this.loading = true;

        const recaptcha = await load("6Ldy7qsUAAAAAMtsyrpPNWJ8p6Z4YLVZ7jFIdPX0");
        await recaptcha.execute("login");

        const fcm_token = await getFirebaseToken(this.$messaging);

        const res = await this.$store.dispatch("passport/AUTHENTICATE", {
          email: this.email,
          password: this.password,
          fcm_token,
        });

        this.handleLoginSuccess(res);
      } catch (error) {
        this.loading = false;

        const data = error.response?.data;

        // 👇 detectar sesión activa
        if (data?.session_exists) {
          this.sessionData = data;
          this.sessionDialog = true;
          return;
        }

        this.$snotify.error(data?.message, "¡Error!");
      }
    },

    handleLoginSuccess(res) {
      this.loading = false;
      this.$snotify.success("Nos encanta tenerte de vuelta.", "¡Bienvenido!");

      switch (res.role_id) {
        case 3:
          this.$router.push({ name: "Bienvenido" });
          break;
        case 4:
          this.$router.push({ name: "WhatsApp" });
          break;
        case 9:
          this.$router.push({ name: "Home Calls" });
          break;
        default:
          this.$router.push({ name: "Home" });
          break;
      }
    },

    // FUNCION PARA RENOVAR SESION ACTIVA
    async handleRenewSession() {
      try {
        this.loading = true;

        // endpoint viene así: "POST /api/agent/renew-session"
        let endpoint = this.sessionData.options.renewal.split(" ")[1];
        endpoint = endpoint.replace(/^\/api/, "");

        await PbxPublicHttpClient.post(endpoint, {
          email: this.email,
          password: this.password,
        });

        this.sessionDialog = false;

        // volver a intentar login
        await this.login();
      } catch (error) {
        this.$snotify.error(error.response?.data?.message, "¡Error!");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.btn-accent-shadow {
  -webkit-box-shadow: 0px 12px 20px -10px rgba(88, 177, 83, 1) !important;
  -moz-box-shadow: 0px 12px 20px -10px rgba(88, 177, 83, 1) !important;
  box-shadow: 0px 12px 20px -10px rgba(88, 177, 83, 1) !important;
}

.btn-primary-shadow {
  -webkit-box-shadow: 0px 12px 20px -10px rgba(51, 50, 127, 1) !important;
  -moz-box-shadow: 0px 12px 20px -10px rgba(51, 50, 127, 1) !important;
  box-shadow: 0px 12px 20px -10px rgba(51, 50, 127, 1) !important;
}
</style>
